var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');
var tablesFilterPreferencesChannel = Radio.channel('tablesFilterPreferencesChannel');

//Models and collections
var Session = require('../../models/session-model');
var Person = require('../../models/person-model');
var Document = require('../../models/document-model');
var Organization = require('../../models/organization');
var ReviewElementStatusesModel = require('../../models/review-element-statuses-model');
var PersonsCollection = require('../../collections/persons-collection');
var FaceToFaceFormModel = require('../../models/face-to-face-form-model');
var MedProfileModel = require('../../models/med-profile-model');

//Views
var Organizations = require('../organizations/organizations');
var OrganizationView = require('../organizations/organization');
var OrganizationPatientsView = require('../organizations/organization-patients');
var Documents = require('../documents/documents');
var PersonsList = require('../persons/persons-view');
var LoginView = require('../persons/login-view');
var PersonView = require('../persons/person-view');
var SignUpView = require('../persons/sign-up-view');
var DocumentView = require('../documents/document-view');
var Settings = require('../settings/settings');
var Relations = require('../relations/relations');
var RelationTypesList = require('../relationtypes/relationtypes');
var RelationTypeView = require('../relationtypes/relationtype-view');
var DocumentUploadView = require('../documents/document-upload-view');
var UploadSignedDocumentView = require('../documents/upload-signed-document-view');
var RolesList = require('../roles/roles-view');
var PasswordChangeForm = require('../persons/password-change-form');
var DocTypesView = require('../document-types/document-types-view');
var PatientsView = require('../patients/patients');
var StatisticsView = require('../statistics/statistics-main-view');
var ImportPersonsView = require('../persons/import-persons-view');
var MergePersonsView = require('../persons/merge-persons-view');
var DocumentHistoryView = require('../documents/history/document-history-view');
var HelpSectionsList = require('../help/help-sections-list');
var HelpPhysicianView = require('../help/help-physician-view');
var HelpOfficeAdminView = require('../help/help-office-admin-view');
var HelpCorporateAdminView = require('../help/help-corporate-admin-view');
var HelpFeedbackView = require('../help/help-feedback-view');
var AuthByInstantToken = require('../persons/auth-by-instant-token');
var ReferralFormView = require('../med-forms/referral-form-view');
var VillagePodiatryFormView = require('../med-forms/village-podiatry-form');
var FaceToFaceFormView = require('../med-forms/face-to-face-form');
var FaceToFaceFormsListView = require('../med-forms/face-to-face-forms-view');

var CommonUtils = require('../../utils/common-utils.js');

var Body = Marionette.View.extend({
    template: require('../../templates/layout/body.html'),
    session: new Session(),

    regions: {
        body: '.body-hook'
    },

    childViewEvents: {
        'server:error': 'onServerError',
        'refresh:document:view': 'onShowDocumentEntity',
        'update:tables:filters:preferences': 'onUpdateTablesFiltersPreferences'
    },

    initialize: function () {
        this.reviewElementStatuses = new ReviewElementStatusesModel();
        this.personsCollection = new PersonsCollection();
        this.utils = new CommonUtils();
        var that = this;
        notificationsChannel.reply('show:notification', function (msg) {
            that.triggerMethod('server:error', msg);
        });

    },

    onServerError: function (message) {
        var msg = "";
        var title = "Error";
        var type = "danger";
        if (typeof message == "object") {
            if (message.code > 199 && message.code < 300) {
                type = "success";
                title = "Success";
            }
            msg = message.message;
        } else {
            msg = message;
        }
        $.notify({
            animate: {
                enter: 'animated bounceIn',
                exit: 'animated bounceOut'
            },
            title: '<strong>' + title + ': </strong>',
            message: msg
        }, {
            type: type,
            delay: 20000,
            z_index: 11000
        });
    },

    byAdmin: function () {
        return _.some(this.session.get('systemRoles'), function (item) {
            return item == 'ADMIN';
        });
    },

    onSessionChanged: function (session) {
        this.session.set(session.toJSON());
    },

    onShowOrganizationsList: function () {
        this.showChildView('body', new Organizations({byAdmin: this.byAdmin()}));
    },

    onShowDocumentsList: function () {
        this.showChildView('body', new Documents({
            user: this.session.get('person'),
            byAdmin: this.byAdmin()
        }));
    },

    onShowDocumentEntity: function (entry) {
        var that = this;
        var documentModel = new Document();
        documentModel.set('id', entry);
        documentModel.fetch({
            success: function () {
                var documentView = new DocumentView({
                    model: documentModel,
                    byAdmin: that.byAdmin()
                });
                that.showChildView('body', documentView);
            }
        });
    },

    onShowDocumentHistoryEntity: function (entry) {
        var that = this;
        var documentModel = new Document();
        documentModel.set('id', entry);
        documentModel.fetch({
            success: function () {
                var documentHistoryView = new DocumentHistoryView({
                    id: documentModel.get('id'),
                    name: documentModel.get('name'),
                    baseParentIdPath: '/api/document/view/',
                    canEdit: that.byAdmin(),
                    byAdmin: that.byAdmin(),
                    document: documentModel.get('object')
                });
                that.showChildView('body', documentHistoryView);
            }
        });
    },

    onShowHistoryEntries: function (entry) {
        var that = this;
        var historyView = new DocumentHistoryView({
            id: entry,
            name: entry,
            canEdit: that.byAdmin()
        });
        that.showChildView('body', historyView);
    },

    onShowDocumentUpload: function () {
        var documentUploadView = new DocumentUploadView();
        this.showChildView('body', documentUploadView);
    },

    onShowDocumentUploadSigned: function () {
        var uploadSignedDocumentView = new UploadSignedDocumentView();
        this.showChildView('body', uploadSignedDocumentView);
    },

    onShowPersonsList: function () {
        this.showChildView('body', new PersonsList());
    },

    onShowOrganizationEntry: function (entry) {
        var that = this;
        var model = new Organization();
        model.set('id', entry);
        model.fetch({
            success: function () {
                that.showChildView('body', new OrganizationView({
                    model: model,
                    user: that.session.get('person'),
                    byAdmin: that.byAdmin()
                }));
            }
        });
    },

    onShowOrganizationEntryPatients: function (entry) {
        var tablesFilterPreferencesList = JSON.parse(localStorage.getItem(this.session.get('person').login + "_" + "tables_filters_sort_preferences")) || [];
        this.showChildView(
            'body',
            new OrganizationPatientsView({
                id: entry,
                byAdmin: this.byAdmin(),
                tablesFilterPreferencesList: tablesFilterPreferencesList
            })
        )
    },

    onUpdateTablesFiltersPreferences: function (tableFilterPreferences) {
        var tablesFilterPreferencesList = JSON.parse(localStorage.getItem(this.session.get('person').login + "_" + "tables_filters_sort_preferences")) || [];
        var foundIndex = _.findIndex(tablesFilterPreferencesList, function (tfp) {
            return tfp.tableName == tableFilterPreferences.tableName;
        });

        if (foundIndex > -1) {
            tablesFilterPreferencesList[foundIndex] = tableFilterPreferences;
        } else {
            tablesFilterPreferencesList.push(tableFilterPreferences);
        }

        localStorage.setItem(this.session.get('person').login + "_" + "tables_filters_sort_preferences", JSON.stringify(tablesFilterPreferencesList));
    },

    onShowPersonEntry: function (entry) {
        var that = this;
        var isSelf = that.session.get('person').login == entry;
        var personModel = new Person();
        personModel.set('id', entry);

        personModel.fetch({
            success: function () {
                that.showChildView('body', new PersonView({
                    model: personModel,
                    byAdmin: that.byAdmin(),
                    isSelf: isSelf
                }));
            }
        });
    },

    onShowLogin: function () {
        this.showChildView('body', new LoginView());
    },

    onShowSignup: function () {
        this.showChildView('body', new SignUpView());
    },

    onShowSettingsList: function () {
        this.showChildView('body', new Settings());
    },

    onShowRelationsList: function () {
        this.showChildView('body', new Relations());
    },

    onShowRelationtypesList: function () {
        this.showChildView('body', new RelationTypesList());
    },

    onShowRelationtypeEntry: function (entry) {
        this.showChildView('body', new RelationTypeView({id: entry}));
    },

    onShowRolesList: function () {
        this.showChildView('body', new RolesList());
    },

    onChangePasswordEntry: function (entry) {
        var isSelf = this.session.get('person').login == entry;
        this.showChildView('body', new PasswordChangeForm({
            id: entry,
            byAdmin: this.byAdmin(),
            isSelf: isSelf,
            defaultPassword: this.session.get('person').defaultPassword
        }));
    },

    onShowDoctypesList: function () {
        this.showChildView('body', new DocTypesView());
    },

    onShowHelpList: function () {
        this.showChildView('body', new HelpSectionsList());
    },

    onShowHelpPhysician: function () {
        this.showChildView('body', new HelpPhysicianView());
    },

    onShowHelpOfficeAdmin: function () {
        this.showChildView('body', new HelpOfficeAdminView());
    },

    onShowHelpCorporateAdmin: function () {
        this.showChildView('body', new HelpCorporateAdminView());
    },

    onShowHelpFeedback: function () {
        this.showChildView('body', new HelpFeedbackView());
    },

    onShowPatientsList: function () {
        this.showChildView('body', new PatientsView({byAdmin: this.byAdmin()}));
    },

    onShowStatistics: function () {
        this.showChildView('body', new StatisticsView());
    },

    onAuthByInstantToken: function (token) {
        this.showChildView('body', new AuthByInstantToken({'token': token}));
    },

    onShowImportPersons: function () {
        this.showChildView('body', new ImportPersonsView());
    },

    onShowMergePersons: function (mergeTo, mergeFrom) {
        this.showChildView('body', new MergePersonsView({
            mergeTo: mergeTo,
            mergeFrom: mergeFrom
        }));
    },

    onShowReferralForm: function () {
        this.showChildView('body', new ReferralFormView());
    },

    onShowVillagePodiatryForm: function (entry) {

        var that = this;
        that.showChildView('body', new VillagePodiatryFormView({
            currentUser: that.session.get('person').login
        }));
    },

    onShowFfForm: function (entry) {

        var that = this;
        if (!entry) {
            that.showChildView('body', new FaceToFaceFormView({
                currentUser: that.session.get('person').login
            }));
        } else {
            var fffModel = new FaceToFaceFormModel({
                id: entry
            });

            fffModel.fetch({
                success: function (ff) {
                    var data = ff.attributes;
                    var medProfileModel = new MedProfileModel();
                    medProfileModel.set('id', 'MP_' + data.patient.id);
                    medProfileModel.fetch({
                        success: function (resp) {
                            that.showChildView('body', new FaceToFaceFormView({
                                model: data,
                                medProfile: _.omit(resp.attributes.object, "@class"),
                                currentUser: that.session.get('person').login
                            }));
                        }
                    });
                }
            });
        }
    },

    onShowFormsList: function () {
        this.showChildView('body', new FaceToFaceFormsListView({currentUser: this.session.get('person').login}));
    }
});

module.exports = Body;


//////////////////
// WEBPACK FOOTER
// ./app/views/layout/body.js
// module id = 205
// module chunks = 0